import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ReportLayerEmbedNodeView } from './ReportLayerEmbed';

export const REPORT_LAYER_EMBED_NAME = 'reportLayerEmbed';

export function createReportLayerEmbedExtension() {
  return Node.create({
    name: REPORT_LAYER_EMBED_NAME,
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,
    addAttributes() {
      return {
        layerId: {
          default: '',
          parseHTML: (element) => element.getAttribute('data-layer-id'),
          renderHTML: (attributes) => ({
            'data-layer-id': attributes.layerId,
          }),
        },
        layerType: {
          default: 'internal',
          parseHTML: (element) => element.getAttribute('data-layer-type'),
          renderHTML: (attributes) => ({
            'data-layer-type': attributes.layerType,
          }),
        },
        label: {
          default: '',
          parseHTML: (element) => element.getAttribute('data-label'),
          renderHTML: (attributes) => ({
            'data-label': attributes.label,
          }),
        },
      };
    },
    parseHTML() {
      return [{ tag: 'div[data-type="report-layer-embed"]' }];
    },
    renderHTML({ HTMLAttributes }) {
      return [
        'div',
        mergeAttributes(HTMLAttributes, {
          'data-type': 'report-layer-embed',
          class: 'report-layer-embed',
        }),
      ];
    },
    addNodeView() {
      return ReactNodeViewRenderer(ReportLayerEmbedNodeView);
    },
  });
}
